import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { DateRange } from 'owa-datetime-utils';
import { EventsCacheLockId, getEventsInDateRangeFromLock } from 'owa-events-cache';
import { getEventsCache } from '../../selectors/eventsCacheSelectors';
import { isRecurringMaster } from 'owa-calendar-event-capabilities';

export function getCalendarEventsForDateRange(
    lockId: EventsCacheLockId,
    folderId: string,
    dateRange: DateRange
): CalendarEvent[] {
    const events = getEventsInDateRangeFromLock(dateRange, lockId, getEventsCache(folderId));
    return (events ? events : []).filter(
        // Return all items except the recurring master
        event => !isRecurringMaster(event.CalendarItemType)
    );
}
